import { InvoiceLineColumn } from '@features/invoices/types/invoiceLineColumn'

export const INVOICE_LINE_COLUMNS_ORDER: InvoiceLineColumn[] = [
  'description',
  'productType',
  'date',
  'quantity',
  'unit',
  'unitPrice',
  'discount',
  'vatPct',
  'netTotal',
  'total',
]
